import { escapeRegExp } from 'lodash';
import Highlighter from 'react-highlight-words';
import styled from 'styled-components';
import { ModelEntitySearchResponseItem } from '../../../../../../../../common/model/search/types';
import { uppercaseFirstLetter } from '../../../../../../../untidy/texts';
import { BouColor } from '../../../../../../generic/global/bou-colors';
import { sanitizeSearch } from '../../shared';

interface Props {
  item: ModelEntitySearchResponseItem;
}

export function DescriptionBlock(props: Props) {
  const { item } = props;
  if (!item.description) {
    return <Root />;
  }
  return (
    <Root>
      <Highlighter
        textToHighlight={`${uppercaseFirstLetter(item.description)}`}
        searchWords={item.query && item.query.length > 3 ? [escapeRegExp(item.query)] : []}
        sanitize={sanitizeSearch}
        highlightStyle={{ backgroundColor: BouColor.TOOL_TEXT_HIGHLIGHT_YELLOW }}
      />
    </Root>
  );
}

const Root = styled.div`
  color: ${BouColor.PLATFORM_TEXT_GRAY_LIGHT};
  flex-basis: 0px;
  flex-grow: 1;
  font-weight: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
